import { apiRequest } from './client'
import { demoSuppliersPage } from '../dev/buyerDemoData'
import { withDemoUi } from '../dev/demoMode'
import { readInt, readString } from './json'

export type MySupplierDto = {
  supplierOrganizationId: number
  supplierName: string
  contactFullName: string | null
  phone: string | null
  messenger: string | null
  email: string | null
  ordersCount: number
  lastRfqRequestId: number | null
  lastOrderedAt: string | null
}

export type MySuppliersPageDto = {
  items: MySupplierDto[]
  page: number
  size: number
  totalElements: number
  totalPages: number
}

type Raw = Record<string, unknown>

const normalizeSupplier = (json: Raw): MySupplierDto => ({
  supplierOrganizationId: readInt(json, 'supplierOrganizationId', 'supplier_organization_id'),
  supplierName: readString(json, 'supplierName', 'supplier_name') ?? '',
  contactFullName: readString(json, 'contactFullName', 'contact_full_name'),
  phone: (json.phone as string | null) ?? null,
  messenger: (json.messenger as string | null) ?? null,
  email: (json.email as string | null) ?? null,
  ordersCount: Number(json.ordersCount ?? json.orders_count ?? 0),
  lastRfqRequestId:
    json.lastRfqRequestId != null
      ? Number(json.lastRfqRequestId)
      : json.last_rfq_request_id != null
        ? Number(json.last_rfq_request_id)
        : null,
  lastOrderedAt: readString(json, 'lastOrderedAt', 'last_ordered_at'),
})

const normalizePage = (json: Raw): MySuppliersPageDto => ({
  items: ((json.items as Raw[] | undefined) ?? []).map(normalizeSupplier),
  page: Number(json.page ?? 0),
  size: Number(json.size ?? 0),
  totalElements: Number(json.totalElements ?? json.total_elements ?? 0),
  totalPages: Number(json.totalPages ?? json.total_pages ?? 0),
})

export const listMySuppliers = async (
  organizationId: number,
  page = 0,
  size = 50,
): Promise<MySuppliersPageDto> =>
  withDemoUi(demoSuppliersPage(), async () => {
  const result = await apiRequest<Raw>(
    `/buyer/suppliers/my?organizationId=${organizationId}&page=${page}&size=${size}`,
  )
  return normalizePage(result)
})
